const PREFIX = '@@CATEGORIES/';

export const SET_LOADING = `${PREFIX}SET_LOADING`;
export const GET_CATEGORIES = `${PREFIX}GET_CATEGORIES`;
export const SET_CATEGORIES = `${PREFIX}SET_CATEGORIES`;
